import React from "react";
import type { ISvgProps } from "components/icons/shared_props";
import { MAIN_THEME } from "styles/theme";

export default function CapitalIcon({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.uiExtraDark,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1444 6.25045H1.64437C1.42335 6.25045 1.21139 6.33825 1.05511 6.49453C0.898833 6.65081 0.811035 6.86277 0.811035 7.08378V17.0838C0.811035 17.3048 0.898833 17.5168 1.05511 17.673C1.21139 17.8293 1.42335 17.9171 1.64437 17.9171H19.1444C19.3654 17.9171 19.5773 17.8293 19.7336 17.673C19.8899 17.5168 19.9777 17.3048 19.9777 17.0838V7.08378C19.9777 6.86277 19.8899 6.65081 19.7336 6.49453C19.5773 6.33825 19.3654 6.25045 19.1444 6.25045ZM10.3944 15.0004C9.81751 15.0004 9.2536 14.8294 8.77395 14.5089C8.29431 14.1884 7.92048 13.7329 7.69972 13.1999C7.47896 12.667 7.4212 12.0805 7.53374 11.5148C7.64628 10.949 7.92407 10.4293 8.33197 10.0214C8.73988 9.61349 9.25958 9.3357 9.82535 9.22316C10.3911 9.11062 10.9776 9.16838 11.5105 9.38913C12.0435 9.60989 12.499 9.98373 12.8195 10.4634C13.14 10.943 13.311 11.5069 13.311 12.0838C13.311 12.8573 13.0037 13.5992 12.4568 14.1462C11.9098 14.6932 11.1679 15.0004 10.3944 15.0004V15.0004Z"
        fill="white"
      />
      <path
        d="M3.31087 5.00045H17.4775C17.6986 5.00045 17.9105 4.91265 18.0668 4.75637C18.2231 4.60009 18.3109 4.38813 18.3109 4.16711C18.3109 3.9461 18.2231 3.73414 18.0668 3.57786C17.9105 3.42158 17.6986 3.33378 17.4775 3.33378H3.31087C3.08986 3.33378 2.8779 3.42158 2.72162 3.57786C2.56534 3.73414 2.47754 3.9461 2.47754 4.16711C2.47754 4.38813 2.56534 4.60009 2.72162 4.75637C2.8779 4.91265 3.08986 5.00045 3.31087 5.00045V5.00045Z"
        fill="white"
      />
      <path
        d="M4.97786 2.08378H15.8112C16.0322 2.08378 16.2442 1.99598 16.4005 1.8397C16.5567 1.68342 16.6445 1.47146 16.6445 1.25045C16.6445 1.02943 16.5567 0.817472 16.4005 0.661192C16.2442 0.504912 16.0322 0.417114 15.8112 0.417114H4.97786C4.75685 0.417114 4.54489 0.504912 4.38861 0.661192C4.23233 0.817472 4.14453 1.02943 4.14453 1.25045C4.14453 1.47146 4.23233 1.68342 4.38861 1.8397C4.54489 1.99598 4.75685 2.08378 4.97786 2.08378Z"
        fill="white"
      />
    </svg>
  );
}
